module.exports = __webpack_public_path__ + "static/media/folder.3999925b.svg";